import RecoveryEdit from './RecoveryEdit';

export default RecoveryEdit;
